/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnregisterCampaignRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {UnregisterCampaignResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const unregisterCampaign = (request: UnregisterCampaignRequest, options?: CashRequestOptions) => post<UnregisterCampaignRequest, UnregisterCampaignResponse>("/2.0/cash/unregister-campaign", request, {...options, rejectOnError: true })